<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Alta de Paciente Masivo</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>PM_plan_pxMasivo</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos"> Alta de Pacientes masivo</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="empresa">Empresa</label>
                  <v-select
                      label="nombreComercial"
                      id="compania"
                      v-model="compania"
                      :options="lstCompania"
                      @input="seleccinarEmpresa($event)"
                      required
                  >
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
              </b-form-group>
            </b-col>
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="plan">Planes</label>
                  <v-select
                      label="nombrePlan"
                      id="plan_convenio"
                      v-model="planConvenio"
                      :options="lstPlanesConvenios"
                      required
                      :disabled="compania === null"
                  >
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col size="6">
          <b-form-group align="left">
            <label for="plan">Archivo</label>
            <b-form-file v-model="archivo" placeholder="Seleccionar archivo" browse-text="Abrir" type="file" @change="cargarArchivo($event)"></b-form-file>
            <b-form-text id="password-help-block">
              El archivo de carga de pacientes debe tener los siguientes datos en el orden establecido( La columna correspondiente esta entre parentesis):

              <ul>
                <li>(A) Apellido Paterno*</li>
                <li>(B) Apellido Materno*</li>
                <li>(C) Nombre*</li>
                <li>(D) Fecha de Nacimiento*</li>
                <li>(E) Genero <small>(Opcional)***</small></li>
                <li>(F) Vip <small>(Opcional)</small></li>
                <li>(G) Poliza <small>(Opcional)</small></li>
                <li>(H) Fecha inicial de vigencia <small>(Opcional)</small></li>
                <li>(I) Fecha fin de vigencia <small>(Opcional)</small></li>
                <li>(J) Tipo de asegurado <small>(Opcional)</small></li>
                <li>(K) Número de empleado <small>(Opcional)</small></li>
                <li>(L) Número de Membresia</li>
              </ul>

              <p>* Si no se especifican estos datos se asume que la vigencia para el paciente es la misma que la vigencia del  pla/convenio en que se dará de alta.</p>
              <p>*** 1.- Masculino.</p>
              <p>*** 2.- Femenino.</p>
              <p>*** 3.- No responder.</p>
              <br>
              <p><small>Nota: revisar que la fecha ingresadas en el archivo tengan formato <strong>FECHA</strong>
                <br>
                El archivo no debe tener ningun tipo de margen.
              </small></p>

              <a href="/files/formato.xlsx" download> Descargar Formato</a>

            </b-form-text>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
      <div class="m-3" align="center"  v-if="loaderDetalle">
        <b-spinner variant="primary" label="Spinning"></b-spinner> Cargando...
      </div>
      <b-row v-if="pacientes.length > 0">
        <b-table
            id="Pacientes"
            thead-tr-class="columnas"
            :items="pacientes"
            :fields="fields"
            :per-page="registrosPorPaginaDetalle"
            :current-page="paginaActualDetalle"
            responsive="true"
            class="parrafos"
            fixed
        >
          <template v-slot:cell(fechaNacimiento)="row">
            {{ row.item.fechaNacimiento | formatoFecha }}
          </template>
          <template v-slot:cell(fechaInicio)="row">
            {{ row.item.fechaInicio | formatoFecha }}
          </template>
          <template v-slot:cell(fechaFin)="row">
            {{ row.item.fechaFin | formatoFecha }}
          </template>
          <template v-slot:cell(index)="row">
            {{ row.index +1}}
          </template>
        </b-table>
        <b-col></b-col>
        <b-col v-if="!loaderDetalle">
          <b-pagination
              v-if="
              pacientes !== undefined && pacientes.length > 100
            "
              align="center"
              v-model="paginaActualDetalle"
              :total-rows="pacientes.length"
              :per-page="registrosPorPaginaDetalle"
              aria-controls="tabla"
          ></b-pagination>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row v-if="resultado.length > 0">
        <b-table
            id="Pacientes"
            thead-tr-class="columnas"
            :items="resultado"
            :fields="fieldRespuesta"
            :per-page="registrosPorPaginaDetalle"
            :current-page="paginaActualResultado"
            responsive="true"
            class="parrafos"
            fixed
        >

          <template v-slot:cell(estatus)="row">

            <b-badge v-if="row.item.estatus" variant="primary">
              Actualizado
            </b-badge>
            <b-badge v-else variant="success">
              Nuevo
            </b-badge>
          </template>
          <template v-slot:cell(index)="row">
            {{ row.index +1}}
          </template>
        </b-table>
      </b-row>
      <b-col></b-col>
      <b-col v-if="!loader">
        <b-pagination
            v-if="
              resultado !== undefined && resultado.length > 100
            "
            align="center"
            v-model="paginaActualResultado"
            :total-rows="resultado.length"
            :per-page="registrosPorPaginaDetalle"
            aria-controls="tabla"
        ></b-pagination>
      </b-col>
      <b-col></b-col>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="validar" :disabled="loader">
            <span v-if="!loader">Guardar</span>
            <span v-if="loader">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span> </b-button>
        </b-col>
      </b-row>
      <br>
      <br>
      <br>
      <br>
    </b-container>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import Header from "@/components/Header";
import moment from "moment";
export default {
  name: "altaPlanesMasivo",
  components: {
    Header,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      compania: null,
      loader: false,
      planConvenio: null,
      archivo: null,
      lstCompania: [],
      lstPlanesConvenios: [],
      file: [],
      pacientes: [],
      resultado: [],
      fields: [
        { key: "index", label: "Num.", sortable: true },
        { key: "apellidoPaterno", label: "Apellido Paterno", sortable: true },
        { key: "apellidoMaterno", label: "Apellido Materno", sortable: true },
        { key: "nombre", label: "Nombre(s)", sortable: true },
        { key: "fechaNacimiento", label: "Fecha de Nacimeinto", sortable: true },
        { key: "genero", label: "Genero", sortable: true },
        { key: "vip", label: "VIP", sortable: true },
        { key: "poliza", label: "Poliza", sortable: true },
        { key: "fechaInicio", label: "Fecha de Inicio", sortable: true },
        { key: "fechaFin", label: "Fecha de Fin", sortable: true },
        { key: "tipoAsegurado", label: "Tipo de asegurado", sortable: true },
        { key: "numeroEmpleado", label: "Numero de Empleado", sortable: true },
        { key: "numeroMembresia", label: "Numero de Membresia", sortable: true }
      ],
      fieldRespuesta: [
        { key: "index", label: "Num.", sortable: true },
        { key: "nombre", label: "Nombre Paciente", sortable: true },
        { key: "fecha", label: "Fecha de Nacimeinto", sortable: true },
        { key: "estatus", label: "Estatus", sortable: true }
      ],
      idCanalOrigen: 31,
      evento:[],
      idArchivo: null,


      loaderDetalle: false,
      registrosPorPaginaDetalle: 100,
      paginaActualDetalle: 0,
      paginaActualResultado: 0,
    }
  },
  mounted() {
    this.obtenerListaEmpresas();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerListaEmpresas() {
      this.$http
          .get(this.$api + "empresas/obtener")
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstCompania = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstCompania.push(item);
              });
            }
          })
          .catch(function (error) {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
    },
    obtenerPlanesEmpresa(empresa) {
      // this.loaderPlanes = true;
      this.planConvenio = null;
      const parametros = {idEmpresa: empresa.idEmpresa}
      var url = "empresas/obtener/planes";

      this.$http
          .post(
              this.$api + url, parametros
          )
          .then((response) => {
            // this.loaderPlanes = false;
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstPlanesConvenios = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstPlanesConvenios.push(item);
              });
            }
          })
          .catch(function (error) {
            // this.loaderPlanes = false;
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => {
            this.plan_convenio = true;
          });
    },
    seleccinarEmpresa(evento) {
      this.lstPlanesConvenios = [];
      this.planConvenio = null;
      this.plan_convenio = false;
      this.obtenerPlanesEmpresa(evento);
    },
    cargarArchivo(e) {
      this.loaderDetalle = true;
      this.evento=e;
      this.resultado = [];
      this.pacientes = [];
      const files = e.target.files;
      const fileReader = new FileReader(); // construction function that can read the file content
      fileReader.onload = ev => {
        const data = ev.target.result;
        const workbook = XLSX.read(data, {
          type: "binary" // binary
        });
        const wsname = workbook.SheetNames[0]; //take the first sheet
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //Get the data in this table
        let lista = []
        // ws.map((value) => {
        //   const datos = Object.values(value) // data for each line
        //
        //   if(datos !== null ){
        //     lista.push(datos)
        //   }
        //
        // })

        lista = ws;

        lista.map(value => {
          if (value["PATERNO"] === undefined || value["MATERNO"] === undefined || value["NOMBRE"] === undefined || value["FECHA"] === undefined){
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "El formato no cumple con los campos básicos en uno registro",
            })
            return false;
          }
          const fecha =  new Date((value["FECHA"] - (25567 + 1))*86400*1000);
          const fechai = value["FECHA INICIAL"] != undefined ? new Date((value["FECHA INICIAL"] - (25567 + 1))*86400*1000): null;
          const fechaf =  value["FECHA FIN"] != undefined ? new Date((value["FECHA FIN"] - (25567 + 1))*86400*1000): null;
          const fechaNacimiento = new Date(fecha.getFullYear(), fecha.getMonth() , fecha.getDate(), 8, 0, 0, 0);
          const fechaInicio = fechai != null ? new Date(fechai.getFullYear(), fechai.getMonth() , fechai.getDate(), 8, 0, 0, 0): null;
          const fechaFin = fechaf != null ? new Date(fechaf.getFullYear(), fechaf.getMonth() , fechaf.getDate(), 8, 0, 0, 0): null;
          const pat = {
            apellidoPaterno: value["PATERNO"].trimLeft().trimRight(),
            apellidoMaterno: value["MATERNO"].trimLeft().trimRight(),

            nombre: value["NOMBRE"].trimLeft().trimRight(),
            fechaNacimiento: fechaNacimiento,
            genero: value["GENERO"],
            vip: value["VIP"],
            poliza: value["POLIZA"],
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            tipoAsegurado: value["TIPO DE ASEGURADO"],
            numeroEmpleado: value["NUMERO DE EMPLEADO"],
            numeroMembresia: value["NUMERO DE MEMBRESIA"]
          }

          this.pacientes.push(pat);
        })
        this.loaderDetalle = false;
      };
      fileReader.readAsBinaryString(files[0]);
    },
    validar() {
      if(this.compania === null){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione una empresa",
        })
        return false;
      }

      if(this.planConvenio === null){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione un plan",
        })
        return false;
      }

      if(this.pacientes.length === 0){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "No hay pacientes",
        })
        return false;
      }

      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
        text: "¿Los datos de los pacientes son correctos?",
      }).then((aceptar) => {
        if (aceptar.value) {
          this.guardarArchivoExcel();
        }
      });
    },
    guardar(){
      this.loader = true;
      this.$http.post(this.$api + "planConvenio/plan-paciente-masiva?idPlan="+this.planConvenio.idPlan+"&idEmpresa="+this.compania.idEmpresa+"&idCanalOrigen="+this.idCanalOrigen+"&idArchivo="+this.idArchivo, this.pacientes).then((respuesta) => {
        if (respuesta.data.data) {
          let datos = {
            nuevos: null,
            encontrados: null,
            lista : []
          };
          datos = respuesta.data.data;
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
            html:'<p>Plan actualizado con éxito para los pacientes</p>' +
                '<br>' +
                '<p><label>Pacientes Nuevos: </label><span>'+datos.nuevos+' </span></p>' +
                '<label>Pacientes encontrados en el plan: </label><span> '+datos.encontrados+' </span>' ,
          });
          this.resultado = [];

          datos.lista.map(value => {
            value.fecha =  moment(value.fecha)
                .utc()
                .format("DD/MM/YYYY");

            this.resultado.push(value)
          })

          this.resultado = datos.lista
          this.pacientes = [];
          this.compania = null;
          this.planConvenio = null;
          this.archivo = null;
        }
      }).finally(()=> {
        this.loader = false;
      });
    },
    guardarArchivoExcel(){
      const datos={
        idEmpresa:this.compania.idEmpresa,
        idCuenta: this.planConvenio.idCuenta,
        idPlan: this.planConvenio.idPlan,
        nombreArchivo:this.evento.target.files[0].name,
        tamanio:this.evento.target.files[0].size,
        canal: this.idCanalOrigen,
        movimiento: 3,
        progress:"",
        totalRegistrosCargados: 0
      }
      this.$http.post(this.$api+"portal/catalogo/guardarExecel",datos).then((respuesta) => {
        if (respuesta.data.data) {
          this.idArchivo = respuesta.data.data;
          this.guardar();
        }
      })
          .catch(function (error) {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "Entendido",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(()=> {
          });
    }
  }
}
</script>

<style scoped>

</style>
